import React from 'react';
import Footer from '../components/Footer';
import NavBar from '../components/NavBar';

export default class ContactPage extends React.Component {

    constructor() {
        super();
    }

    render() {
        return <div><NavBar /><div style={{display:"flex", paddingTop:200,flexDirection:"column"}}>

            <div style={{paddingLeft:"15%", paddingBottom:200}}>
                <p style={{fontSize:32, lineHeight:"40px", fontWeight:"500"}}>Bize ulaşın</p>
                <p style={{fontWeight:"600", marginTop:20,fontSize:16}}>Genel destek</p>
                <p style={{marginTop:5}}>Email: destek@tasimacim.com <br />
Telefon: +90 850 532 85 05<br />
{/* Servis Saatleri: Pazartesi – Pazar 08:00-22:00 */}</p>
<p style={{fontWeight:"600", marginTop:20,fontSize:16}}>İşletmeler için</p>
                <p style={{marginTop:5}}>business@tasimacim.com<br />
                Telefon: +90 850 532 85 05</p>
{/* <p style={{fontWeight:"600", marginTop:20,fontSize:16}}>Media enquiry and speakership invitation</p>
                <p style={{marginTop:5}}>media@gogox.com</p> */}
                
                <p style={{marginTop:20}}>Kavacık Mah. Fatih Sultan Mehmet Cad. Tonoğlu No: 3 / 4 Beykoz / İstanbul</p>

                   <p style={{marginTop:5}}>Taşımacım Nakliyat Lojistik Aracılık Hizmetleri Limited Şirketi</p>
            </div>

            <Footer />
        </div></div>
    }
}